
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { ClientOnboardingComponent } from './client-onboarding.component';
import { ClientOnboardingRoutingModule } from './client-onboarding-routing.module';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SignaturePadModule } from 'angular2-signaturepad';
import { GridAllModule, GridModule } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { FilesComponent } from './files/files.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MyDatePickerModule,
    SignaturePadModule,
    NgxUiLoaderModule,
    GridModule,
    MaskedTextBoxModule,
    PdfViewerModule,
    PDFExportModule,
    ClientOnboardingRoutingModule,
    GridAllModule ,
  ],
  declarations: [
    ClientOnboardingComponent,
    FilesComponent,
   
  ],
  exports:[ ClientOnboardingComponent,
    FilesComponent,
 
  ]
    ,
     providers: [FilesComponent]
})
export class clientOnboardingModule { }